import { links } from "@octopusdeploy/portal-routes";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import * as React from "react";
import { repository } from "~/clientInstance";
import { SkeletonLoadingLayout } from "~/components/SkeletonLoadingLayout/SkeletonLoadingLayout";
import { AsyncInternalRedirect } from "../AsyncInternalRedirect";
export function DefaultPlatformHubPageRedirect() {
    const processTemplates = useBooleanFlagValue("blueprints", false);
    const projectTemplates = useBooleanFlagValue("project-templates", false);
    const compliancePolicies = useBooleanFlagValue("compliance-policies", false);
    return (<AsyncInternalRedirect loader={async () => {
            const licenseCheck = await repository.Licenses.getFeatures();
            // TODO once we have implemented the other license feature checks, we can update to check each one individually.
            // For now, we just check if ProcessTemplates is enabled as it means the others are available, as they get generated together.
            if (!licenseCheck.EnabledFeatures.includes("ProcessTemplates")) {
                return links.platformHubUpsellPage.generateUrl();
            }
            if (processTemplates) {
                return links.processTemplatesPage.generateUrl();
            }
            if (projectTemplates) {
                return links.projectTemplatesPage.generateUrl();
            }
            if (compliancePolicies) {
                return links.policiesPage.generateUrl();
            }
            return links.platformHubUpsellPage.generateUrl();
        }} renderWhenLoading={<SkeletonLoadingLayout errors={undefined}/>}/>);
}
